<template>
  <checkbox-multi-select
    :labelSmall="true"
    :label="label"
    :options="dataList"
    v-model="selections"
    :trackBy="trackBy"
    ref="multiSelectRef"
    :displayField="displayField"
    :style="{ marginTop: '-7px' }"
    :itemTemplate="itemTemplate"
    @filtering="$emit('filtering', $event.text)"
    @select="selectItem"
    @removed="removedItem"
  >
  </checkbox-multi-select>
</template>
<script>
import Vue from "vue";
import CheckboxMultiSelect from "@/components/Base/CheckboxMultiSelect.vue";
import { getId } from "@/helpers/utils";

const itemSelections = Vue.component("itemTemplate", {
  template: `<span>
  <span class='username'>{{ data.full_name ? data.full_name : data.name}}</span> - <span class ='student-code'>{{ data.full_name ? (data.staff_code || data.student_code) : data.status}}</span>
  </span>`,
  data() {
    return {
      data: {}
    };
  }
});

export default {
  name: "class-select-component",
  components: { CheckboxMultiSelect },
  props: ["dataList", "displayField", "label", "trackBy"],
  data() {
    return {
      fields: { text: this.displayField, value: this.trackBy },
      itemTemplate: function(e) {
        return {
          template: itemSelections
        };
      },
      selections: [],
      memorizedSelections: []
    };
  },
  methods: {
    getMemorizedSelected() {
      return this.memorizedSelections;
    },
    setDefaultSelections() {
      this.selections = [...this.memorizedSelections[this.trackBy]];
    },
    selectItem(event) {
      this.memorizedSelections.push(event.itemData);
    },
    removedItem(event) {
      console.log(event);
      const { itemData } = event;
      if (this.displayField === "full_name") {
        this.memorizedSelections = this.memorizedSelections.filter(
          item => item.username !== itemData.username
        );
      }
      if (this.displayField === "name") {
        this.memorizedSelections = this.memorizedSelections.filter(
          item => item.name !== itemData.name
        );
      }
    }
  },
  watch: {
    dataList: function() {
      this.setDefaultSelections();
    },
    selections: function() {
      let dataSelections = [];
      this.memorizedSelections.forEach(item => {
        if (this.displayField === "full_name") {
          dataSelections = dataSelections.concat(item.uuid);
        } else if (this.displayField === "name")
          dataSelections = dataSelections.concat(getId(item));
      });
      this.$emit("update-selections", dataSelections);
    }
  }
};
</script>
